<template>
  <div>
    <NewHomePage v-if="isShowNewHome"></NewHomePage>
    <NewHomePageV3 v-else-if="isShowNewHomeV3"></NewHomePageV3>
    <OldHomePage v-else></OldHomePage>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useSettingStore from '@/store/setting'
import useRequestLocationStore from '@/store/requestLocation'
import { VN_COUNTRY_CODE, CHINA_COUNTRY_CODE } from '@/utils'
import OldHomePage from './home/Home.vue'
import NewHomePage from './new-home/Home.vue'
import NewHomePageV3 from './new-home-v3/Home.vue'

const settingStore = useSettingStore()
const requestLocation = useRequestLocationStore()

const isShowNewHome = computed(
  () =>
    !!(
      requestLocation.countryCode &&
      requestLocation.countryCode.toUpperCase() != VN_COUNTRY_CODE &&
      !CHINA_COUNTRY_CODE.includes(requestLocation.countryCode.toUpperCase()) &&
      settingStore.pages?.general?.homePageVersion?.toUpperCase() == 'V2'
    )
)
const isShowNewHomeV3 = computed(
  () => settingStore.pages?.general?.homePageVersion?.toUpperCase() == 'V3'
)
</script>
